var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2502 13.5H6.75024C5.5076 13.5 4.50024 14.5073 4.50024 15.75V45C4.50024 46.2427 5.5076 47.25 6.75024 47.25H47.2502C48.4929 47.25 49.5002 46.2427 49.5002 45V15.75C49.5002 14.5073 48.4929 13.5 47.2502 13.5Z",
    fill: "#2F88FF",
    stroke: "url(#paint0_linear_4312_8279)",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1333 22.6815C33.3738 22.6815 33.5688 22.8764 33.5688 23.1169V37.6331C33.5688 37.8736 33.3738 38.0685 33.1333 38.0685H14.1172C13.8767 38.0685 13.6817 37.8736 13.6817 37.6331V23.1169C13.6817 22.8764 13.8767 22.6815 14.1172 22.6815H33.1333Z",
    fill: "url(#paint1_radial_4312_8279)",
    stroke: "url(#paint2_linear_4312_8279)",
    strokeWidth: 2.6129
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7502 5.0625L25.9775 13.5L38.2502 2.25",
    stroke: "#FF1D8F",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7502 20.25V21.375",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7502 28.125V29.25",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4312_8279",
    x1: 7.8391,
    y1: 14.8065,
    x2: 48.7746,
    y2: 48.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1D8F",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#6EB2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE65B2",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4312_8279",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7971 30.375) rotate(90) scale(9 11.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4312_8279",
    x1: 13.9356,
    y1: 22.6451,
    x2: 33.9678,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C84CF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#BC61B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1D8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTv);
export default __webpack_public_path__ + "static/media/icon-tv.e592644d8f3710c7eb653870b4556355.svg";
export { ForwardRef as ReactComponent };